import React, { useEffect, useRef } from "react";
import { useTranslation, LangType } from "./hooks/useTranslation";

export const videoUrl = "https://pub-2ceb5fd1d48749a5b8ef4628293e3f4c.r2.dev";

interface HomeProps {
  lang: LangType;
}

export const Home: React.FC<HomeProps> = ({ lang }) => {
  const vidRef = useRef<HTMLVideoElement | null>(null);
  const t = useTranslation(lang);

  useEffect(() => {
    const video = vidRef.current;
    if (video && video.paused) {
      const playPromise = video.play();
      // Handle the case where play() might not return a Promise (in test environments)
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    }
  }, []);

  return (
    <main className="page-container">
      <section className="home">
        <div className="column">
          <p className="text about-me">{t("aboutMe")}</p>
        </div>
        <div className="column interactive-container">
          <video
            ref={vidRef}
            className="video"
            autoPlay
            muted
            poster={`${videoUrl}/author.png`}
            aria-label="Author video"
          >
            <source src={`${videoUrl}/portrait.mp4`} type="video/mp4" />
          </video>
        </div>
      </section>
    </main>
  );
};
